import { matchPath } from "react-router-dom";

interface RouteTitle {
  pattern: string;
  title: string;
  parent?: string;
  parentPath?: string;
}

export interface PageTitleResult {
  title: string;
  parent?: string;
  parentPath?: string;
}

// Rotas mais específicas devem vir antes das genéricas
const ROUTE_TITLES: RouteTitle[] = [
  // Admin
  {
    pattern: "/admin/saude",
    title: "Saúde do Sistema",
    parent: "Admin",
    parentPath: "/admin",
  },
  { pattern: "/admin", title: "Admin" },

  // Usuários
  {
    pattern: "/usuarios/novo",
    title: "Novo Usuário",
    parent: "Usuários",
    parentPath: "/usuarios",
  },
  {
    pattern: "/usuarios/editar/:id",
    title: "Editar Usuário",
    parent: "Usuários",
    parentPath: "/usuarios",
  },
  { pattern: "/usuarios", title: "Usuários" },
  { pattern: "/editar-usuario", title: "Editar Perfil" },
  { pattern: "/perfil-empresa", title: "Perfil da empresa" },

  // Agências
  {
    pattern: "/agencias/produtos/ads",
    title: "Ads",
    parent: "Agências",
    parentPath: "/agencias",
  },
  {
    pattern: "/agencias/produtos/representacao",
    title: "Representação",
    parent: "Agências",
    parentPath: "/agencias",
  },
  {
    pattern: "/agencias/produtos",
    title: "Produtos",
    parent: "Agências",
    parentPath: "/agencias",
  },
  { pattern: "/agencias", title: "Agências" },

  // Desks
  {
    pattern: "/painel-producao/ocupacao-produtores",
    title: "Ocupação por Produtor",
    parent: "Painel de Produção",
  },
  { pattern: "/desks/download/:id", title: "Desks" },
  { pattern: "/desks/:deskId", title: "Desks" },
  { pattern: "/desks", title: "Desks" },

  // Contatos
  {
    pattern: "/contatos/adicionar",
    title: "Adicionar Contato",
    parent: "Contatos",
    parentPath: "/contatos",
  },
  { pattern: "/contatos", title: "Contatos" },

  // Produtos (criação)
  {
    pattern: "/produtos/representacao/adicionar",
    title: "Adicionar",
    parent: "Representação",
    parentPath: "/produtos/representacao",
  },
  {
    pattern: "/produtos/representacao",
    title: "Representação",
    parent: "Produtos",
    parentPath: "/produtos",
  },
  {
    pattern: "/produtos/ads",
    title: "Ads",
    parent: "Produtos",
    parentPath: "/produtos",
  },
  { pattern: "/produtos", title: "Produtos" },
  { pattern: "/products", title: "Produtos de Criação" },

  // Empresas - Controller (mais específicos primeiro)
  {
    pattern:
      "/empresas/produtos/controller/:id_empresa/:id_produto/:id_canal/:id_formato",
    title: "Controller",
    parent: "Empresas",
    parentPath: "/empresas",
  },
  {
    pattern: "/empresas/produtos/controller/:id_empresa/:id_produto/:id_canal",
    title: "Controller",
    parent: "Empresas",
    parentPath: "/empresas",
  },
  {
    pattern: "/empresas/produtos/controller/:id_empresa/:id_produto",
    title: "Controller",
    parent: "Empresas",
    parentPath: "/empresas",
  },
  {
    pattern: "/empresas/produtos/controller/:id_empresa",
    title: "Controller",
    parent: "Empresas",
    parentPath: "/empresas",
  },

  // Empresas - Criação
  {
    pattern: "/empresas/produtos/criacao/:id",
    title: "Produtos",
    parent: "Empresas",
    parentPath: "/empresas",
  },
  { pattern: "/empresas", title: "Empresas" },

  // Controller (DRE)
  {
    pattern: "/controller/dre",
    title: "DRE",
    parent: "Controller",
    parentPath: "/controller",
  },
  { pattern: "/controller", title: "Controller" },

  // Prospecções
  { pattern: "/prospeccoes/:idProspect", title: "Prospecções" },
  { pattern: "/prospeccoes", title: "Prospecções" },

  // AD-Link Usuários
  {
    pattern: "/ad-link/usuarios",
    title: "Usuários",
    parent: "AD-Link",
    parentPath: "/ad-link",
  },

  // Vagas / Recrutamento
  { pattern: "/dash-recrutamento", title: "Recrutamento" },
  { pattern: "/criar-nova-vaga/:idEdit", title: "Editar Vaga" },
  { pattern: "/criar-nova-vaga", title: "Criar Vaga" },

  // Mensagens
  {
    pattern: "/mensagens/chat",
    title: "Chat",
    parent: "Mensagens",
    parentPath: "/mensagens",
  },
  { pattern: "/mensagens", title: "Mensagens" },

  // Feedback
  {
    pattern: "/feedback/:id",
    title: "Detalhe do Report",
    parent: "Feedback",
    parentPath: "/feedback",
  },
  { pattern: "/feedback", title: "Feedback" },
  {
    pattern: "/admin/feedback/:id",
    title: "Detalhe do Report",
    parent: "Feedback",
    parentPath: "/admin/feedback",
  },
  {
    pattern: "/admin/feedback",
    title: "Feedback",
    parent: "Admin",
    parentPath: "/admin",
  },

  // Demais páginas
  { pattern: "/home", title: "Home" },
  {
    pattern: "/negocios-em-aberto",
    title: "Negócios em Aberto",
    parent: "Overview",
    parentPath: "/overview",
  },
  {
    pattern: "/negocios-ativos",
    title: "Negócios Ativos",
    parent: "Overview",
    parentPath: "/overview",
  },
  {
    pattern: "/nao-midia/negocios-em-aberto",
    title: "Negócios em Aberto",
    parent: "Overview",
    parentPath: "/overview",
  },
  {
    pattern: "/nao-midia/negocios-ativos",
    title: "Negócios Ativos",
    parent: "Overview",
    parentPath: "/overview",
  },
  { pattern: "/overview/:idCampanha", title: "Overview" },
  { pattern: "/overview", title: "Overview" },
  { pattern: "/organizacoes", title: "Organizações" },
  { pattern: "/dashboard", title: "Dashboard" },
  { pattern: "/clientes", title: "Clientes" },
  { pattern: "/representados", title: "Representados" },
  { pattern: "/representantes", title: "Representantes" },
  { pattern: "/relatorios", title: "Relatórios" },
  { pattern: "/vendas", title: "Área de Vendas" },
  { pattern: "/midia", title: "Área de Mídia" },
  { pattern: "/metas", title: "Metas" },
  { pattern: "/formatos", title: "Formatos" },
  { pattern: "/jobs", title: "Jobs" },
  { pattern: "/campanhas", title: "Campanhas" },
  { pattern: "/painel-campanhas", title: "Painel de Campanhas" },
  { pattern: "/empresas-fornecedores", title: "Fornecedores" },
  { pattern: "/notas-fiscais", title: "Notas Fiscais" },
  { pattern: "/tarefas", title: "Tarefas" },
  { pattern: "/tarefasExpansao", title: "Tarefas" },
  { pattern: "/reunioes", title: "Reuniões" },
  { pattern: "/reunioesExpansao", title: "Reuniões" },
  { pattern: "/reunioesCalendario", title: "Reuniões" },
  { pattern: "/aniversariantes", title: "Aniversariantes" },
  { pattern: "/notificacoes", title: "Notificações" },
];

export function getPageTitle(pathname: string): PageTitleResult {
  for (const route of ROUTE_TITLES) {
    const match = matchPath({ path: route.pattern, end: true }, pathname);
    if (match) {
      return {
        title: route.title,
        parent: route.parent,
        parentPath: route.parentPath,
      };
    }
  }
  return { title: "" };
}
